import React, {useState} from 'react';
import Popup from '../common/components/Popup';
import TextInput from '../common/components/TextInput';
import Permission from './Permission';
import {PERMISSIONS, DEFINED_ROLES} from '../../constants/permission';
import _ from 'lodash'


interface addRolePopupProps {
    showPopup: boolean,
    setShowPopup: (value: boolean) => void,
    addRole: (newRole: newRoleType) => void,
}

export interface newRoleType {
    userRoleName: string,
    permissions: string[],
    permission: string,
}

function AddRolePopup(props: addRolePopupProps) {
    const {showPopup, setShowPopup, addRole} = props;

    const [
        newRole,
        setNewRole,
    ] = useState<newRoleType>({
        userRoleName: '',
        permissions: [
            PERMISSIONS.R,
        ],
        permission: 'R',
    });

    const resetNewRole = (): newRoleType => {
        return {
            userRoleName: '',
            permissions: [
                PERMISSIONS.R,
            ],
            permission: 'R',
        };
    };

    const handleClose = () => {
        setNewRole(resetNewRole());
        setShowPopup(false);
    };

    const handleOnChange = (text: string, inputId: keyof newRoleType) => {
        setNewRole((prevState) => {
            return {
                ...prevState,
                [inputId]: text,
            };
        });
    };

    const validateRole = () => {
        if (newRole.userRoleName !== '') {
            addRole(newRole);
            setNewRole(resetNewRole());
        }
    };

    const handleOnClickPermission = (checked: boolean, permission: string) => {
        let currentPermissions = [
            ...newRole.permissions,
        ];
        if (checked) {
            currentPermissions.push(permission);
        } else {
            currentPermissions = currentPermissions.filter((perm) =>
                perm !== permission);
        }
        currentPermissions.sort();
        let permissionShortName = 'R'
        Object.keys(DEFINED_ROLES).forEach((role) => {
            const roles = [
                ...DEFINED_ROLES[role].permissions,
            ].sort();
            if (_.isEqual(roles, currentPermissions)) {
                permissionShortName = role;
            }
        });

        setNewRole((prevState) => {
            return {
                ...prevState,
                permissions: currentPermissions,
                permission: permissionShortName,
            }
        })
    }
 
    return (
        <Popup
            show={showPopup}
            onClose={handleClose}
            title='Add New Role'
            size='lg'
            primaryCtaText='Add New Role'
            disablePrimaryCta={newRole.userRoleName === ''}
            primaryCtaOnClick={validateRole}
            secondaryCtaText='Back'
            secondaryCtaOnClick={handleClose}
        >
            <div className='mb-2'>
                <label className='form-label'>Role Name</label>
                <TextInput type='text' placeholder='Enter Role Name' onChange={(text) => handleOnChange(text, 'userRoleName')} text={newRole.userRoleName} style={{width: '100%'}}></TextInput>
            </div>
            <div className='permission-header'>SET PERMISSIONS</div>
            <Permission
                selectedPermission={[PERMISSIONS.R]}
                userRoleId='new-role'
                onClick={handleOnClickPermission}
            />
        </Popup>
    );
}

export default AddRolePopup;
